import React, { Fragment } from 'react'
import Header4 from 'src/components/Header/Header4'
import { Layout, Menu , Tree } from 'antd';
import './index.css'
// import { Switch, Route } from 'react-router';
import {Switch, Route ,Redirect} from 'react-router-dom'
import Broadcast from './OnlineHelpPage/Broadcast/Broadcast';
import ProductSearch from './OnlineHelpPage/ProductSearch/ProductSearch';
import Production from './OnlineHelpPage/Production/Production';
import ToolbarAction from './OnlineHelpPage/ToolbarAction/ToolbarAction';
import LocalMapLayer from './OnlineHelpPage/LocalMapLayer/LocalMapLayer';
import LayerManagement from './OnlineHelpPage/LayerManagement/LayerManagement';
import LongAndLat from './OnlineHelpPage/LongAndLat/LongAndLat';
import StationPosition from './OnlineHelpPage/StationPosition/StationPosition';
import FloodAnalysis from './OnlineHelpPage/FloodAnalysis/FloodAnalysis';
import DimensionCorversion from './OnlineHelpPage/DimensionConversion/DimensionConversion'
import ElevationAnalysis from './OnlineHelpPage/ElevationAnalysis/ElevationAnalysis'
import AreaMeasurement from './OnlineHelpPage/AreaMeasurement/AreaMeasurement'
import DistanceMeasurement from './OnlineHelpPage/DistanceMeasurement/DistanceMeasurement'
import ClearAll from './OnlineHelpPage/ClearAll/ClearAll'
import LivingClassOrdinary from './OnlineHelpPage/LivingClassOrdinary/LivingClassOrdinary'
import LivingClassAdmin from './OnlineHelpPage/LivingClassAdmin/LivingClassAdmin'
import WebRealTimeCommunication from './OnlineHelpPage/WebRealTimeCommunication/WebRealTimeCommunication'
import CloudDisk from './OnlineHelpPage/CloudDisk/CloudDisk'
import AdminTaskManagement from './OnlineHelpPage/AdminTaskManagement/AdminTaskManagement'
import StaffTaskManagement from './OnlineHelpPage/StaffTaskManagement/StaffTaskManagement'
import OrdinaryTaskManament from './OnlineHelpPage/OrdinaryTaskManagement/OrdinaryTaskManament';
import ElecRealTimeCommunication from './OnlineHelpPage/ElecRealTimeCommunication/ElecRealTimeCommunication'
import CloudDesktop from './OnlineHelpPage/CloudDesktop/CloudDesktop'
import DataVisualization from './OnlineHelpPage/DataVisualization/DataVisualization'
import AppMarket from './OnlineHelpPage/AppMarket/AppMarket'
import TransferList from './OnlineHelpPage/TransferList/TransferList'
const { DirectoryTree } = Tree;
// const menudata = [{
//   name: '常规操作',
//   img:"images/directSeeding.jpg",
// }, {
//   name: '常见问题',
//   img:"images/0-2.jpg",
// }
// ]

const treeData = [
  {
    title: '门户网站',
    key: '01',
    children: [
      
      {
        title: '地球检索、下载、工具栏',
        key: '01-002',
        children: [
          {
            title: '球上产品检索',
            key: '01-002-001',
            isLeaf:true
          },
          {
            title: '生产定制',
            key: '01-002-002',
            isLeaf:true
          },
          {
            title: '数字地球工具栏操作',
            key: '01-002-003',
            isLeaf:true
          },
          {
            title: '使用本地图层功能',
            key: '01-002-004',
            isLeaf:true
          },
          {
            title: '使用图层管理功能',
            key: '01-002-005',
            isLeaf:true
          },
          {
            title: '使用经纬线功能',
            key: '01-002-006',
            isLeaf:true
          },
          {
            title: '使用场站定位功能',
            key: '01-002-007',
            isLeaf:true
          },
          {
            title: '使用水淹分析功能',
            key: '01-002-008',
            isLeaf:true
          },
          {
            title: '使用二三维转换',
            key: '01-002-009',
            isLeaf:true
          },
          {
            title: '使用高程分析',
            key: '01-002-010',
            isLeaf:true
          },
          {
            title: '使用面积量测功能',
            key: '01-002-011',
            isLeaf:true
          },
          {
            title: '使用距离量测功能',
            key: '01-002-012',
            isLeaf:true
          },
          {
            title: '使用清除功能',
            key: '01-002-013',
            isLeaf:true
          }
        ]
      },
      {
        title: '在线课堂',
        key: '01-003',
        children: [
          {
            title: '普通用户使用在线课堂',
            key: '01-003-001',
            isLeaf:true
          },
          {
            title: '管理员使用在线课堂',
            key: '01-003-002',
            isLeaf:true
          }
        ]
      },
      
    ]
  },
  {
    title: '客户端',
    key: '02',
    children: [
      {
        title: '任务管理系统',
        key: '02-001',
        children: [
          {
            title: '管理员管理任务的整体流程',
            key: '02-001-001',
            isLeaf:true
          },
          {
            title: '业务员处理整个任务中的单个步骤',
            key: '02-001-002',
            isLeaf:true
          },
          {
            title: '普通用户没有任务管理的权限',
            key: '02-001-003',
            isLeaf:true
          }
        ]
      },
      
      {
        title: '数据可视化功能',
        key: '02-004',
        isLeaf:true
      },
      {
        title: '应用市场',
        key: '02-005',
        isLeaf:true
      },
      {
        title: '传输列表功能',
        key: '02-006',
        isLeaf:true
      }
    ]
  },
  {
    title: '常见问题',
    key: '03',
    children: [
      {
        title: '门户网站直播如何使用',
        key: '01-001',
        isLeaf:true
      },
      {
        title: '门户网站即时通信如何使用',
        key: '01-004',
        isLeaf:true
      },
      {
        title: '门户网站个人云盘如何使用',
        key: '01-005',
        isLeaf:true
      },
      {
        title: '客户端即时通信功能如何使用',
        key: '02-002',
        isLeaf:true
      },
      {
        title: '客户端云桌面功能如何使用',
        key: '02-003',
        isLeaf:true
      },
    ]
  }
]
class OnlineHelp extends React.Component {
  state = {
    key: this.props.history.location.pathname.split('/')[3] || '01-001',
  };

  componentDidMount() {
    console.log('检查在线帮助页面',this.state.key);
  }

  leftSelected = (keys,info) => {
    // console.log(keys,info)
    switch (keys[0]) {
      case '01-001':
        this.props.history.push('/OnlineHelp/Broadcast/01-001')
        break;
      case '01-002-001':
        this.props.history.push('/OnlineHelp/ProductSearch/01-002-001')
        break;
      case '01-002-002':
        this.props.history.push('/OnlineHelp/Production/01-002-002')
        break;
      case '01-002-003':
        this.props.history.push('/OnlineHelp/ToolbarAction/01-002-003')
        break;
      case '01-002-004':
        this.props.history.push('/OnlineHelp/LocalMapLayer/01-002-004')
        break;
      case '01-002-005':
        this.props.history.push('/OnlineHelp/LayerManagement/01-002-005')
        break;
      case '01-002-006':
        this.props.history.push('/OnlineHelp/LongAndLat/01-002-006')
        break;
      case '01-002-007':
        this.props.history.push('/OnlineHelp/StationPosition/01-002-007')
        break;
      case '01-002-008':
        this.props.history.push('/OnlineHelp/FloodAnalysis/01-002-008')
        break;
      case '01-002-009':
        this.props.history.push('/OnlineHelp/DimensionCorversion/01-002-009')
        break;
      case '01-002-010':
        this.props.history.push('/OnlineHelp/ElevationAnalysis/01-002-010')
        break;
      case '01-002-011':
        this.props.history.push('/OnlineHelp/AreaMeasurement/01-002-011')
        break;
      case '01-002-012':
        this.props.history.push('/OnlineHelp/DistanceMeasurement/01-002-012')
        break;
      case '01-002-013':
        this.props.history.push('/OnlineHelp/ClearAll/01-002-013')
        break;
      case '01-003-001':
        this.props.history.push('/OnlineHelp/LivingClassOrdinary/01-003-001')
        break;
      case '01-003-002':
        this.props.history.push('/OnlineHelp/LivingClassAdmin/01-003-002')
        break;
      case '01-004':
        this.props.history.push('/OnlineHelp/WebRealTimeCommunication/01-004')
        break;
      case '01-005':
        this.props.history.push('/OnlineHelp/CloudDisk/01-005')
        break;
      case '02-001-001':
        this.props.history.push('/OnlineHelp/AdminTaskManagement/02-001-001')
        break;
      case '02-001-002':
        this.props.history.push('/OnlineHelp/StaffTaskManagement/02-001-002')
        break;
      case '02-001-003':
        this.props.history.push('/OnlineHelp/OrdinaryTaskManament/02-001-003')
        break;
      case '02-002':
        this.props.history.push('/OnlineHelp/ElecRealTimeCommunication/02-002')
        break;
      case '02-003':
        this.props.history.push('/OnlineHelp/CloudDesktop/02-003')
        break;
      case '02-004':
        this.props.history.push('/OnlineHelp/DataVisualization/02-004')
        break;
      case '02-005':
        this.props.history.push('/OnlineHelp/AppMarket/02-005')
        break;
      case '02-006':
        this.props.history.push('/OnlineHelp/TransferList/02-006')
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <>
        <Header4></Header4>
        <Layout className='onlineHelp-main'>
          <div className='onlineHelp-main-content'>
            <div trigger={null} className='onlineHelp-sider'  >
              <DirectoryTree
                multiple
                treeData={treeData}
                // defaultExpandAll
                defaultSelectedKeys={[this.state.key]}
                onSelect={(keys,info)=>{this.leftSelected(keys,info)}}
              >
              </DirectoryTree>
            </div>
            <Switch>
              {/* 直播 */}
              <Route path='/OnlineHelp/Broadcast/01-001' component={Broadcast}></Route>
              {/* 球上产品检索 */}
              <Route path='/OnlineHelp/ProductSearch/01-002-001' component={ProductSearch}></Route>
              {/* 生产定制 */}
              <Route path='/OnlineHelp/Production/01-002-002' component={Production}></Route>
              {/* 数字地球工具栏操作 */}
              <Route path='/OnlineHelp/ToolbarAction/01-002-003' component={ToolbarAction}></Route>
              {/* 使用本地图层功能 */}
              <Route path='/OnlineHelp/LocalMapLayer/01-002-004' component={LocalMapLayer}></Route>
              {/* 使用图层管理功能*/}
              <Route path='/OnlineHelp/LayerManagement/01-002-005' component={LayerManagement}></Route>
              {/* 使用经纬线功能 */}
              <Route path='/OnlineHelp/LongAndLat/01-002-006' component={LongAndLat}></Route>
              {/* 使用场站定位功能 */}
              <Route path='/OnlineHelp/StationPosition/01-002-007' component={StationPosition}></Route>
              {/* 使用水淹分析功能 */}
              <Route path='/OnlineHelp/FloodAnalysis/01-002-008' component={FloodAnalysis}></Route>
              {/* 使用二三维转换 */}
              <Route path='/OnlineHelp/DimensionCorversion/01-002-009' component={DimensionCorversion}></Route>
              {/* 使用高程分析 */}
              <Route path='/OnlineHelp/ElevationAnalysis/01-002-010' component={ElevationAnalysis}></Route>
              {/* 使用面积量测功能 */}
              <Route path='/OnlineHelp/AreaMeasurement/01-002-011' component={AreaMeasurement}></Route>
              {/* 使用距离量测功能 */}
              <Route path='/OnlineHelp/DistanceMeasurement/01-002-012' component={DistanceMeasurement}></Route>
              {/* 使用清除功能 */}
              <Route path='/OnlineHelp/ClearAll/01-002-013' component={ClearAll}></Route>
              {/* 普通用户使用在线课堂 */}
              <Route path='/OnlineHelp/LivingClassOrdinary/01-003-001' component={LivingClassOrdinary}></Route>
              {/* 管理员使用在线课堂 */}
              <Route path='/OnlineHelp/LivingClassAdmin/01-003-002' component={LivingClassAdmin}></Route>
              {/* 即时通信_网页端 */}
              <Route path='/OnlineHelp/WebRealTimeCommunication/01-004' component={WebRealTimeCommunication}></Route>
              {/* 个人云盘 */}
              <Route path='/OnlineHelp/CloudDisk/01-005' component={CloudDisk}></Route>
              {/* 管理员管理任务的整体流程 */}
              <Route path='/OnlineHelp/AdminTaskManagement/02-001-001' component={AdminTaskManagement}></Route>
              {/* 业务员处理整个任务中的单个步骤 */}
              <Route path='/OnlineHelp/StaffTaskManagement/02-001-002' component={StaffTaskManagement}></Route>
              {/* 普通用户没有任务管理的权限 */}
              <Route path='/OnlineHelp/OrdinaryTaskManament/02-001-003' component={OrdinaryTaskManament}></Route>
              {/* 即时通信_客户端 */}
              <Route path='/OnlineHelp/ElecRealTimeCommunication/02-002' component={ElecRealTimeCommunication}></Route>
              {/* 云桌面功能 */}
              <Route path='/OnlineHelp/CloudDesktop/02-003' component={CloudDesktop}></Route>
              {/* 数据可视化 */}
              <Route path='/OnlineHelp/DataVisualization/02-004' component={DataVisualization}></Route>
              {/* 应用市场 */}
              <Route path='/OnlineHelp/AppMarket/02-005' component={AppMarket}></Route>
              {/* 传输列表功能 */}
              <Route path='/OnlineHelp/TransferList/02-006' component={TransferList}></Route>
             

              <Redirect path='/OnlineHelp' to='/OnlineHelp/Broadcast/01-001'></Redirect>
              {/* <Route path="/OnlineHelp" element={<Navigate to='/OnlineHelp/Broadcast/01-001'></Navigate>} /> */}
              {/* <Navigate to="/OnlineHelp/Broadcast/01-001" /> */}
            </Switch>
          </div>
        </Layout>
      </>
    )
  }
}


export default OnlineHelp